class WbPeopleSlider {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.initSliders();
      resolve();
    });
  }

  initSliders() {
    document.querySelectorAll('.wb-list-of-people__slider')?.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        breakpoints: {
          576: {
            spaceBetween: 20,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1200: {
            spaceBetween: 30,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          2000: {
            spaceBetween: 40,
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        },
      });
    });
  }
}

BarbaController.addObject(new WbPeopleSlider());
